import { ReactElement, useEffect } from 'react'
import cn from 'classnames'
import { ToastType, useUI } from '@corratech/pylot-ui/context'
import { Cross, Error, Success, Warning } from '@components/icons'
import s from './Toast.module.scss'
type ToastProps = {
    isToastFixed?: boolean
}

const Toast = ({ isToastFixed }: ToastProps): ReactElement => {
    const { closeToast, toastText, displayToast, toastType, isFixed } = useUI()
    const processedIsToastFixed = isToastFixed || isFixed
    useEffect(() => {
        //scroll to top for toast visibility
        //TODO: check ref.current.scrollToView() method
        if (displayToast && !processedIsToastFixed) {
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }
    }, [displayToast])
    return (
        <div
            className={cn(
                s['toast-container'],
                'toast-container',
                {
                    block: displayToast,
                    hidden: !displayToast,
                    'bg-alert-danger-toast': toastType === ToastType.Danger,
                    'bg-alert-warning-toast': toastType === ToastType.Warning,
                    'bg-alert-success-toast': toastType === ToastType.Success,
                    'is-fixed': processedIsToastFixed
                },
                processedIsToastFixed && s['is-fixed']
            )}
        >
            <div className={cn(s['toast-content'], 'toast-content')}>
                <div
                    className={cn(
                        s['toast-content-inner'],
                        'toast-content-inner'
                    )}
                >
                    {toastType === ToastType.Success && <Success />}
                    {toastType === ToastType.Danger && <Error />}
                    {toastType === ToastType.Warning && <Warning />}
                    <div className={cn(s['toast-text'], 'toast-text')}>
                        {toastText}
                    </div>
                </div>
                <Cross
                    className={cn(s['close-icon'], 'close-icon')}
                    onClick={closeToast}
                />
            </div>
        </div>
    )
}
export default Toast
